import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';
import { getSocket } from '../services/socket';

export default function useInvitesCounts(userType) {
  const [pending, setPending] = useState(0);

  // Mesmo contorno do interceptor de api.js usado em ConvitesPanel.js: URLs
  // "/community/*" pegam community_token por padrão, mas organizador só tem
  // "token" no localStorage — precisa do header explícito.
  const refetch = useCallback(async () => {
    try {
      const headers = userType === 'organizer'
        ? { Authorization: `Bearer ${localStorage.getItem('token')}` }
        : undefined;
      const r = await api.get(`/community/invites/counts?userType=${userType}`, { headers });
      setPending(r.data.pending_received || 0);
    } catch { /* silencia — badge nao e critico */ }
  }, [userType]);

  useEffect(() => {
    refetch();
    const socket = getSocket();
    if (!socket) return;
    const handler = () => refetch();
    // invite:update é emitido hoje só no cancelamento (backend/routes/communityInvitesCancel.js).
    // new_notification é o evento que invitePlayer/applyToTeam/respondInvite realmente emitem
    // (communityInvitesController.js linhas 63, 143, 219, 226) — sem ouvir esse aqui o badge
    // nunca atualizava em tempo real pra criação/aceite/recusa de convite, só pro cancelamento.
    socket.on('invite:update', handler);
    socket.on('new_notification', handler);
    return () => {
      socket.off('invite:update', handler);
      socket.off('new_notification', handler);
    };
  }, [refetch]);

  return { pending, refetch };
}
